// import { chosenSelect } from './chosen-select';
// import { swiperJs } from './swiper';

import { initVendors } from './vendors/main';
import { initWidgets } from './widgets/main';
import { initAssets } from './assets/_main';
import { initAPI } from './api/_main';
import {initHeader} from './header/_main';
import {utility} from './utility/_main';
import {forms} from './forms';
export const initJs = () => {
    initVendors();
    initWidgets();
    initAssets();
    initAPI();
    initHeader();
    utility();
    forms.init();
}